/**
 * Dépôt LOCAL des sauvegardes de sécurité créées juste avant une restauration.
 * Le contenu est déjà chiffré (enveloppe Hybride) : le dépôt ne manipule que du texte opaque.
 */
export interface HybridSafetyBackupStore {
  write(name: string, content: string): Promise<{ location: string }>;
}

export class MemorySafetyBackupStore implements HybridSafetyBackupStore {
  readonly files = new Map<string, string>();

  async write(name: string, content: string): Promise<{ location: string }> {
    this.files.set(name, content);
    return { location: `memory://${name}` };
  }
}

export class ElectronSafetyBackupStore implements HybridSafetyBackupStore {
  async write(name: string, content: string): Promise<{ location: string }> {
    const fn = window.electron?.hybridSafetyWrite;
    if (!fn) throw new Error('Dépôt de sauvegarde de sécurité indisponible (hors Electron)');
    const res = await fn({ name, content });
    if (!res?.ok) throw new Error('Écriture de la sauvegarde de sécurité refusée');
    return { location: res.location };
  }
}
